'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  ', '\n\n  align-items: center;\n  color: ', ';\n  display: inline-flex;\n  font-weight: 500;\n  text-decoration: underline;\n  margin: 0 20px 5px 0;\n  position: relative;\n\n  &::after {\n    position: absolute;\n    right: -10px;\n  }\n'], ['\n  ', '\n\n  align-items: center;\n  color: ', ';\n  display: inline-flex;\n  font-weight: 500;\n  text-decoration: underline;\n  margin: 0 20px 5px 0;\n  position: relative;\n\n  &::after {\n    position: absolute;\n    right: -10px;\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Arrow = require('../../../mixins/Arrow');

var _Arrow2 = _interopRequireDefault(_Arrow);

var _config = require('../../../config.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var arrowSettings = {
  arrow: 'right',
  position: 'after',
  color: _config.colors.darkRed,
  size: '12px'
};

var Link = _styledComponents2.default.a(_templateObject, (0, _Arrow2.default)(arrowSettings), _config.colors.black);

Link.displayName = 'Link';

exports.default = Link;